import { render, staticRenderFns } from "./TargetUsageComponent.vue?vue&type=template&id=139222eb"
import script from "./TargetUsageComponent.vue?vue&type=script&lang=js"
export * from "./TargetUsageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports